import styled from 'styled-components';
import { COLOR } from '../../constants';

// Modal overlay
export const ModalOverlay = styled.div<{isOpen: boolean}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

// Modal container
export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    max-width: 95vw;
    max-height: 95vh;
    border-radius: 8px;
  }
`;

// Modal header
export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;

  @media (max-width: 768px) {
    padding: 15px;
    border-radius: 8px 8px 0 0;
  }

  h2 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 600;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
`;

// Close button
export const CloseButton = styled.button.attrs({
  type: 'button' // Força o tipo button para prevenir submit
})`
  background: rgba(255,255,255,0.2);
  border: none;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;

  &:hover {
    background: rgba(255,255,255,0.3);
    transform: scale(1.1);
  }
`;

// Modal content
export const ModalContent = styled.div`
  padding: 25px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const DeviceFrame = styled.div`
  background: #000;
  border-radius: 25px;
  padding: 20px 12px;
  margin: 20px auto;
  max-width: 350px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 20px;
    padding: 15px 10px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 4px;
    background: #333;
    border-radius: 2px;
  }
`;

export const ModeSelector = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;

  button {
    padding: 10px 20px;
    border: 2px solid #ddd;
    background: white;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 100px;
    
    /* Força tipo button para prevenir submit */
    &[type="button"] {
      /* Aplicado via props no componente */
    }

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 8px 16px;
      min-width: 80px;
    }

    &:hover {
      border-color: ${COLOR.PRIMARY};
      color: ${COLOR.PRIMARY};
      transform: translateY(-1px);
    }

    &.active {
      background: ${COLOR.PRIMARY};
      color: white;
      border-color: ${COLOR.PRIMARY};
      transform: translateY(-1px);
    }
  }
`;

export const CourseGrid = styled.div<{mode: string}>`
  display: grid;
  gap: 10px;
  height: 400px;
  overflow-y: auto;
  padding-right: 6px;

  @media (max-width: 768px) {
    height: 350px;
    gap: 8px;
  }

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #333;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #666;
    border-radius: 2px;

    &:hover {
      background: #888;
    }
  }

  ${props => {
    switch (props.mode) {
      case 'poster':
        return `
          grid-template-columns: repeat(2, 1fr);
          @media (max-width: 480px) {
            grid-template-columns: repeat(2, 1fr);
          }
        `;
      case 'cover':
        return 'grid-template-columns: 1fr;';
      case 'both':
        return 'grid-template-columns: 1fr;';
      default:
        return 'grid-template-columns: repeat(2, 1fr);';
    }
  }}
`;

export const CourseCard = styled.div<{isFirst?: boolean}>`
  background: #1a1a1a;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  border: ${props => props.isFirst ? '2px solid #ff6b6b' : '1px solid #333'};

  &:hover {
    transform: scale(1.02);
  }
`;

export const PosterImage = styled.img`
  width: 100%;
  aspect-ratio: 2/3;
  object-fit: cover;
  display: block;
`;

export const CoverImage = styled.img`
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
`;

export const CourseInfo = styled.div`
  padding: 8px;
`;

export const CourseTitle = styled.h5`
  color: white;
  font-size: 11px;
  margin: 0 0 4px 0;
  font-weight: 600;
  line-height: 1.2;
  
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CourseDescription = styled.p`
  color: #ccc;
  font-size: 9px;
  margin: 0;
  line-height: 1.3;
  
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PreviewToggle = styled.button.attrs({
  type: 'button' // Força o tipo button para prevenir submit
})`
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  i {
    font-size: 16px;
  }
`;

export const InfoText = styled.div`
  font-size: 13px;
  color: #666;
  text-align: center;
  margin-top: 15px;
  line-height: 1.5;
  padding: 12px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 6px;
  border: 1px solid rgba(102, 126, 234, 0.1);
`;
